(function($){
	$(document).ready(function(){
		const $slider = $('.news-slider');

		$slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			infinite: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	});

	const links = document.querySelectorAll('a[href*="themes/universum-verlag/scorm-demo/"]');
	let modal = null;
	let iframe = null;
	let closeBtn = null;
	let previousScrollY = 0;
	let iframeEscHandler = null;

	function createModal(){
		modal = document.createElement('div');
		modal.className = 'modal';
		modal.innerHTML = `
			<div class="modal-content" role="dialog" aria-modal="true" aria-label="SCORM-Demo">
				<button type="button" class="modal-close" aria-label="Demo schließen">
					<span>Demo schließen</span>
					<i class="icon-clear"></i>
				</button>
				<div class="scorm-demo">
					<iframe src="" frameborder="0" tabindex="-1"></iframe>
				</div>
			</div>
		`;
		document.body.appendChild(modal);

		iframe = modal.querySelector('iframe');
		closeBtn = modal.querySelector('.modal-close');

		closeBtn.addEventListener('click', function(e){
			e.preventDefault();
			closeModal();
		});

		modal.addEventListener('click', function(e){
			const inside = e.target.closest('.modal-content');
			if(!inside) {
				closeModal();
			}
		});
	}

	function bindEscGlobal(){
		document.addEventListener('keydown', onKeydown, true);
		window.addEventListener('keydown', onKeydown, true);
	}

	function unbindEscGlobal(){
		document.removeEventListener('keydown', onKeydown, true);
		window.removeEventListener('keydown', onKeydown, true);
	}

	function bindEscInsideIframe(){
		if(!iframe) {

			return;
		}

		iframeEscHandler = function(e){
			if(e.key === 'Escape' || e.key === 'Esc') {
				e.preventDefault();
				closeModal();
			}
		};

		iframe.addEventListener('load', function(){
			try {
				if(iframe.contentWindow) {
					iframe.contentWindow.addEventListener('keydown', iframeEscHandler, true);
				}
			} catch(err) {
				// Cross-Origin: ignorieren
			}
		});
	}

	function unbindEscInsideIframe(){
		if(!iframe || !iframeEscHandler) {

			return;
		}

		try {
			if(iframe.contentWindow) {
				iframe.contentWindow.removeEventListener('keydown', iframeEscHandler, true);
			}
		} catch(err) {
			// Cross-Origin: ignorieren
		}

		iframeEscHandler = null;
	}

	function openModal(url){
		if(!modal) {
			createModal();
		}

		if(!iframe) {

			return;
		}

		iframe.setAttribute('src', url);
		modal.classList.add('is-open');
		lockScroll();
		bindEscGlobal();
		bindEscInsideIframe();

		if(closeBtn) {
			closeBtn.focus();
		}
	}

	function closeModal(){
		if(!modal) {

			return;
		}

		unbindEscInsideIframe();
		unbindEscGlobal();
		unlockScroll();
		modal.remove();
		modal = null;
		iframe = null;
		closeBtn = null;
	}

	function onKeydown(e){
		if(e.key === 'Escape' || e.key === 'Esc') {
			closeModal();
		}
	}

	function lockScroll(){
		previousScrollY = window.scrollY || document.documentElement.scrollTop;
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

		document.documentElement.classList.add('scroll-locked');
		document.body.classList.add('scroll-locked');

		if(scrollbarWidth > 0) {
			document.body.style.paddingRight = scrollbarWidth + 'px';
		}

		document.body.style.top = -previousScrollY + 'px';
		document.body.style.position = 'fixed';
		document.body.style.width = '100%';
	}

	function unlockScroll(){
		const html = document.documentElement;
		const previousBehavior = html.style.scrollBehavior;
		html.style.scrollBehavior = 'auto';

		document.documentElement.classList.remove('scroll-locked');
		document.body.classList.remove('scroll-locked');

		document.body.style.paddingRight = '';
		document.body.style.top = '';
		document.body.style.position = '';
		document.body.style.width = '';

		window.scrollTo(0, previousScrollY);

		html.style.scrollBehavior = previousBehavior;
	}

	function init(){
		links.forEach(function(link){
			link.addEventListener('click', function(e){
				e.preventDefault();
				openModal(link.href);
			});
		});
	}

	if(document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})(jQuery);
